<template>
  <div class="pt-6 narociScitPage" v-if="shieldsLoaded">
    <div class="uvodniText" v-html="getIntroText()"/>
    <izdelki-box class="pt-4" v-loading="!shieldsReLoaded">
      <template v-for="activeShieldType in vrstniRedShieldov">
        <template v-for="shield in izdelkiZaDoticniPrikljucek">
          <template v-for="ps in shield.possibleServices">
            <izdelek
              v-if="ps.id === activeShieldType"
              :title="ps.title.toUpperCase()"
              subtitle="STANDARD"
              :tag="ps.includedInPackage? 'VKLJUČENO V PAKET' : ''"
              :key="ps.title">
              <template #icon>
                <div v-html="ps.icons"></div>
              </template>
              <template #footer>
                <div v-if="ps.automaticDiscountService">
                  <div class="cena">
                    {{ formatPrice(ps.payment) }} / mesec
                  </div>
                </div>
                <div v-else>
                  <div class="cena">
                    {{ formatPrice(ps.includedInPackage ? 0 : ps.price) }} / mesec
                  </div>
                </div>
                <div class="orderButtonContainer">
                  <el-button
                    class="gumb-potrdi"
                    style="width: 130px;"
                    :disabled="ps.disabledMessage !== null"
                    @click="selectedShield = shield; selectedShieldService = ps; selectedShield.toBeConnectedShields = []; narociAktivirajClick()">
                    <span class="uppercase">{{ ps.buttonTitle }}</span>
                  </el-button>
                </div>
                <div v-if="ps.includedInPackage || ps.payment !== null && ps.payment !== ps.price" class="rednaCena">
                  Redna cena: {{ formatPrice(ps.price) }} / mesec
                </div>
              </template>
              <div class="opisAlineja">
                <div><img src="/static/img/kljukica2.svg" width="12px" style="vertical-align: middle; margin-right: 8px;" /></div>
                <div>{{ps.description2}}</div>
              </div>
              <div class="opisAlineja">
                <div><img src="/static/img/kljukica2.svg" width="12px" style="vertical-align: middle; margin-right: 8px;" /></div>
                <div>Preprečevanje potencialno nevarnih ali sumljivih spletnih dejavnosti.</div>
              </div>
              <div class="opisAlineja">
                <div><img src="/static/img/kljukica2.svg" width="12px" style="vertical-align: middle; margin-right: 8px;" /></div>
                <div>Enostavna in takojšnja 24-urna zaščita, s samodejnimi posodobitvami.</div>
              </div>
              <div class="opisAlineja">
                <div><img src="/static/img/kljukica2.svg" width="12px" style="vertical-align: middle; margin-right: 8px;" /></div>
                <div>Brez dodatnega prenašanja in nameščanja programske opreme.</div>
              </div>
            </izdelek>
          </template>
        </template>
      </template>
    </izdelki-box>
    <info-komponenta-globalna class="mb-2 mt-4" style="max-width: 880px;">
      Razlika med antivirusno zaščito Panda in spletno zaščito T-2 Ščit je v njihovem delovanju: antivirusna zaščita
      Panda se osredotoča na odstranjevanje in preprečevanje zlonamerne programske opreme na vaši napravi, medtem ko
      T-2 Ščit blokira dostop do nevarnih spletnih mest, da prepreči okužbo že pri viru. Več informacij najdete na spletni strani:
      <a href="https://www.t-2.net/razlike-med-antivirusno-zascito-panda-spletno-zascito-t-2-scit" target="_blank" style="color: rgb(64, 158, 255) !important;">
        https://www.t-2.net/razlike-med-antivirusno-zascito-panda-spletno-zascito-t-2-scit
      </a>
    </info-komponenta-globalna>

    <div class="seznamNarocenihZascitScit mb-4 mt-6" v-if="shields.activeShields !== null && shields.activeShields.length > 0">
      <div class="title my-2">Seznam naročenih zaščit T-2 ščit</div>
      <el-table
        :data="shields.activeShields"
        class="w100"
        :expand-row-keys="expandRowKeys"
        :row-key="row => row.terminationPointId"
        @expand-change="expandChange"
      >
        <el-table-column
          v-if="!(!xsScreen && smallScreen || xxsScreen)"
          label="Naziv zaščite"
          prop="activeService.title"
          :width="largeScreen ? 200 : 170"
        />
        <el-table-column label="Priključek">
          <template slot-scope="scope">
            {{scope.row.title}}
          </template>
        </el-table-column>
        <el-table-column label="Tip naročila" v-if="largeScreen">
          <template slot-scope="scope">
            {{ scope.row.activeService.includedInPackage ? 'V paketu' : 'Samostojno' }}
          </template>
        </el-table-column>
        <el-table-column label="Datum vklopa"  v-if="!smallToMedScreen">
          <template slot-scope="scope">
            {{FormatDatuma.methods.PoenotenIzgledDatuma(scope.row.activeService.dateActivated, false)}}
          </template>
        </el-table-column>
        <el-table-column label="" align="right" class-name="scitEditIcon" v-if="!largeScreen">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              style="font-weight: bold;"
              :circle="circleIcon"
              @click="selectedShield = scope.row; selectedShieldService = scope.row.activeService; urediDialog = true;"
            >{{circleIcon ? '' : 'Uredi'}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="" align="right" v-if="largeScreen" width="120">
          <template slot-scope="scope">
            <a
              class="odstrani d-flex"
              @click="selectedShield = scope.row; selectedShieldService = scope.row.activeService; odjaviDeaktivirajPopup = true;"
              style="cursor: pointer; justify-content: end;"
            >
              <div><img src="/static/img/Naroci/Icon-awesome-trash-alt.svg"></div>
              <div class="pl-2">
                <span class="krepko crna odmik-levo" style="margin: auto;">
                  ODSTRANI
                </span>
              </div>
            </a>
          </template>
        </el-table-column>

        <el-table-column type="expand">
          <template slot-scope="props">
            <div v-for="(atp, index) in props.row.activeTerminationPoints" class="my-3 d-flex" :key="`atpExtandRow-${index}-${atp.toBeChangedShield}`">
              <div style="flex: auto;" class="d-flex atpExpandRow">
                <div :style="`width: ${largeScreen ? 200 : 170}px;`" class="d-flex my-auto">
                  <div class="pr-1 pl-3 scitIkonaExpanded">
                    <img style="margin-left: 3px; margin-right: 3px;"  v-if="atp.mobilni" src="/static/img/Ikone_Scit/mobile.png">
                    <img v-else src="/static/img/Ikone_Scit/circleNet.png">
                  </div>
                  <div>{{atp.mobilni ? 'Mobilna naprava' : 'Domače omrežje'}}</div>
                </div>
                <template v-if="atp.shield !== null">
                  <el-select
                    class="ml-2"
                    style="flex:1; max-width: 400px;"
                    v-model="atp.toBeChangedShield"
                    @change="connectedShieldChanged(props.row, atp)"
                    :disabled="atp.disabled"
                    v-loading="atp.loading"
                  >
                    <el-option
                      v-for="(mobShield, mobShieldIndex) in [
                        {
                          terminationPointId: null,
                          title: 'Brez'
                        }, atp.shield, ...shields.mobileTerminationPointsForOrder
                      ]"
                      :label="mobShield.title"
                      :value="mobShield.terminationPointId"
                      :key="mobShieldIndex + '-' + mobShield.terminationPointId"
                    ></el-option>
                  </el-select>
                </template>
                <el-select
                  v-else
                  v-model="atp.toBeAddedShield"
                  @change="addNewConnectedShield(props.row, atp)"
                  style="max-width: 400px; flex: auto;"
                  v-loading="atp.loading"
                  class="ml-2"
                >
                  <el-option
                    v-for="(mobShield, mobShieldIndex) in [
                      {
                        terminationPointId: null,
                        title: 'Brez'
                      }, ...shields.mobileTerminationPointsForOrder
                    ]"
                    :label="mobShield.title"
                    :value="mobShield.terminationPointId"
                    :key="'new-' + mobShieldIndex + '-' + mobShield.terminationPointId"
                  ></el-option>
                </el-select>
              </div>
              <div v-if="atp.shield !== null" style="width: 370px;" class="d-flex atpExpandRow">
                <div style="min-width: 200px; justify-content: end;" :class="`d-flex px-2 ${atp.shield.configured ? 'green' : 'red'} my-auto`">
                  <div style="font-size: 20px;" class="pr-1"><i :class="`${atp.shield.configured ? 'el-icon-success' : 'el-icon-error'}`"/></div>
                  <div style="margin-top: auto;margin-bottom: auto;">
                    {{atp.shield.configured ? 'Vklopljena ' : 'Izklopljena '}}
                    <span v-if="atp.shield.configurationDate !== null">
                      {{FormatDatuma.methods.PoenotenIzgledDatuma(atp.shield.configurationDate, false)}}
                    </span>
                  </div>
                </div>
                <div
                  v-loading="atp.shield.loading || atp.loading"
                  style="justify-content: end; align-items: center; display: flex; width: 170px; flex: auto; margin-right: 15px;"
                >
                  <el-checkbox
                    style="margin-top: auto;margin-bottom: auto;"
                    v-model="atp.shield.configurationChanges"
                    @change="spremembaShieldKonfiguracije(atp.shield)"
                    :disabled="atp.shield.loading || !atp.shield.configurationAllowed"
                  />
                  <div
                    class="pl-2"
                    style="cursor: pointer; font-weight: bold;"
                    @click="spremembaKonfiguracijeLabelClick(atp)"
                  >
                    Omogoči zaščito
                  </div>
                </div>
              </div>
            </div>
            <div class="splosni-pogoji">
              Z vklopom soglašam s
              <a :href="povezavaSplosniPogojiStoritve" target="_blank" class="primarna-barva">
                pogoji storitve</a>.
            </div>
          </template>
        </el-table-column>

      </el-table>
      <div>
        <info-komponenta-globalna
          icon="fa fa-exclamation-triangle"
          icon-color="black"
          icon-size="18px"
          text-color="black"
          background-color="white"
          border="solid 1px black"
          class="mt-4"
          font-size="13px"
          style="max-width: 467px;"
        >
          <b>Opozorilo!</b> Vklop ali izklop zaščite lahko poljubno upravljate v okviru naročnine.
          Začasen izklop zaščite ne odjavi naročnine.
          Pri vklopu ali izklopu zaščite bo povezava na kratko prekinjena in ponovno vzpostavljena v nekaj minutah.
        </info-komponenta-globalna>
      </div>
    </div>

    <template v-if="orderNewShield">
      <sprememba-storitev-popup
        :services="servicesForOrder"
        :serviceName="selectedShieldService.title"
        @zapriPopup="narociAktivirajPopup = false;orderNewShield = false; removeExistingShield = false"
        @orderConfirmed="narociAktivirajPopup = false;orderNewShield = false;reloadShields(true)"
      />
    </template>
    <template v-if="removeExistingShield">
      <sprememba-storitev-popup
        :services="servicesForOrder"
        :serviceName="selectedShieldService.title"
        @zapriPopup="narociAktivirajPopup = false;orderNewShield = false; removeExistingShield = false"
        @orderConfirmed="narociAktivirajPopup = false;removeExistingShield = false;reloadShields(true)"
      />
    </template>

    <div>
      <el-dialog
        v-if="odjaviDeaktivirajPopup"
        :width="'530px'"
        append-to-body
        :visible.sync="odjaviDeaktivirajPopup"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
        custom-class="narociScitPopup"
      >
        <template v-slot:title>
          <div style="text-align: left;" class="mt-3 ml-3">
            {{selectedShieldService.includedInPackage ? 'Deaktiviraj' : 'Odjavi'}} {{selectedShieldService.title}}
          </div>
        </template>
        <div class="mb-4">Ste prepričani, da želite {{selectedShieldService.includedInPackage ? 'deaktivirati' : 'odjaviti'}} {{selectedShieldService.title}}?</div>
        <div style="text-align: right;">
          <el-button
            @click="odjaviDeaktivirajPopup = false;"
            class="gumb-crni-okvir"
            style="width:100px; margin-left: 0px; border: 0px !important;"
          >
            Prekliči
          </el-button>
          <el-button @click="removeShield()" :loading="narociVklopiLoading" type="primary">
            Da, {{selectedShieldService.includedInPackage ? 'deaktiviraj' : 'odjavi'}}
          </el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        v-if="narociAktivirajPopup"
        :width="'530px'"
        append-to-body
        :visible.sync="narociAktivirajPopup"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center
        custom-class="narociScitPopup"
      >
        <template v-slot:title>
          <div style="text-align: left;" class="mt-3 ml-3">
            {{selectedShieldService.includedInPackage ? 'AKTIVIRAJ' : 'NAROČI'}} {{selectedShieldService.title}} - Standard
          </div>
        </template>
        <div style="text-align: left">
          <div class="mb-4 dialogText" v-html="narociAktivirajText" style="word-break: break-word;"/>
          <div class="d-flex narociAktivirajPopupFixPrikljucek mb-2" v-if="[StoritevEnum.SCITFIX, StoritevEnum.SCITPAKET].indexOf(selectedShieldService.id) > -1">
            <div style="font-size: 14px;" class="selectLabelTitle mr-2">Domače omrežje: </div>
            <div style="font-size: 14px;">
              <el-select
                v-model="selectedShield.title"
                placeholder="Izberi"
                disabled
              >
                <el-option
                  :key="selectedShield.title"
                  :label="selectedShield.title"
                  :value="selectedShield.title"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div>
            <template v-if="selectedShieldService.maxConnectedMobiles > 0 || selectedShieldService.id === StoritevEnum.SCITMOB">
              <div class="selectLabelTitle">
                {{mobilniPrikljucekPopupWording}}
              </div>
              <el-select
                :multiple="true"
                :multiple-limit="selectedShieldService.maxConnectedMobiles"
                v-model="selectedShield.toBeConnectedShields"
                placeholder="Izberi"
              >
                <el-option
                  v-for="mobShield in shields.mobileTerminationPointsForOrder"
                  :key="mobShield.terminationPointId"
                  :label="mobShield.title"
                  :value="mobShield.terminationPointId"
                ></el-option>
              </el-select>
            </template>
          </div>
          <div v-if="aktivirajInDiamantAliKing" class="d-flex">
            <el-checkbox v-model="strinjanjeZaAktivacijo" />
            <div class="pl-2 mb-2" style="cursor: pointer" @click="strinjanjeZaAktivacijo = !strinjanjeZaAktivacijo">
              Prebral/a sem in se strinjam s Posebnim dogovorom - T-2 Ščit, ki velja za naročilo storitve T-2 Ščit in je objavljen
              <a
                class="primarna-barva"
                href="https://www.t-2.net/splosni-pogoji-podjetja"
                target="_blank"
              >tukaj</a>, v razdelku T-2 Ščit.
            </div>
          </div>
          <div v-if="[StoritevEnum.SCITFIX, StoritevEnum.SCITPAKET].includes(selectedShieldService.id)">
            <info-komponenta-globalna
              icon="fa fa-exclamation-triangle"
              icon-color="black"
              icon-size="18px"
              text-color="black"
              background-color="white"
              border="solid 1px black"
              class="mt-3 mb-8"
              font-size="13px"
              style="max-width: 467px;"
            >
              <b>Opozorilo!</b>
              Ob vklopu zaščite se bo internetna povezava na kratko prekinila in ponovno vzpostavila v nekaj minutah.
            </info-komponenta-globalna>
          </div>
          <div class="buttonsBox">
            <div class="buttonsBoxInfo">
              <div v-if="selectedShieldService.id === StoritevEnum.SCITMOB" class="d-flex" style="font-size: 14px;">
                <div class="pr-4">Št. priključkov: <b>{{selectedShield.toBeConnectedShields.length}}</b></div>
                <div>Cena: <b>{{formatPrice(selectedShield.toBeConnectedShields.length * selectedShieldService.price)}}</b></div>
              </div>
            </div>
            <div style="text-align: right;">
              <el-button
                @click="narociAktivirajPopup = false; strinjanjeZaAktivacijo = false;"
                class="gumb-crni-okvir"
                style="width:100px; margin-left: 0px; border: 0px !important;"
              >
                Prekliči
              </el-button>
              <el-button
                type="primary"
                class="gumb-potrdi uppercase"
                style="width:120px;"
                @click="narociVklopiClick()"
                :loading="narociVklopiLoading"
                :disabled="narociVklopiAktivirajDisabledButton"
              >
                {{selectedShieldService.includedInPackage ? 'AKTIVIRAJ' : 'NAROČI'}}
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <el-dialog
      v-if="oddajZahtevekPopup"
      :width="'530px'"
      append-to-body
      :visible.sync="oddajZahtevekPopup"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      custom-class="narociScitPopup"
    >
      <template v-slot:title>
        <div style="text-align: left;" class="mt-3 ml-3">
          {{oddajZahtevekTitle}}
        </div>
      </template>
      <div v-html="oddajZahtevekText" style="word-break: keep-all;"/>
      <div style="text-align: right;" class="mt-3">
        <el-button
          @click="oddajZahtevekPopup = false;"
          class="gumb-crni-okvir primarna-barva"
          style="width:90px; margin-left: 0px; padding-right: 0px; border: 0px !important; color: black !important;"
        >
          Prekliči
        </el-button>
        <el-button @click="oddajZahtevekClick()" :loading="oddajZahtevekLoading" type="primary" style="font-weight: bold;">ODDAJ ZAHTEVEK</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-if="urediDialog"
      :width="'530px'"
      append-to-body
      :visible.sync="urediDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      custom-class="narociScitPopup"
    >
      <template v-slot:title>
        <div style="text-align: left;" class="mt-3 ml-3">
          {{selectedShieldService.title}}
        </div>
      </template>
      <div style="word-break: keep-all;">
        <div class="py-2 d-flex" style="width: 100%; border-bottom: 1px solid #EBEEF5;">
          <div style="font-weight: bold;">Naziv zaščite:</div>
          <div style="flex: auto; text-align: right;">{{selectedShieldService.title}}</div>
        </div>
        <div class="py-2 d-flex" style="width: 100%; border-bottom: 1px solid #EBEEF5;">
          <div style="font-weight: bold;">Priključek:</div>
          <div style="flex: auto; text-align: right;">{{selectedShield.title}}</div>
        </div>
        <div class="py-2 d-flex" style="width: 100%; border-bottom: 1px solid #EBEEF5;">
          <div style="font-weight: bold;">Tip naročila:</div>
          <div style="flex: auto; text-align: right;">{{ selectedShieldService.includedInPackage ? 'V paketu' : 'Samostojno' }}</div>
        </div>
        <div class="py-2 d-flex" style="width: 100%; border-bottom: 1px solid #EBEEF5;">
          <div style="font-weight: bold;">Datum vklopa:</div>
          <div style="flex: auto; text-align: right;">
            {{FormatDatuma.methods.PoenotenIzgledDatuma(selectedShieldService.dateActivated)}}
          </div>
        </div>
      </div>
      <div style="text-align: right;" class="mt-3">
        <el-button
          @click="urediDialog = false;"
          class="gumb-crni-okvir primarna-barva"
          style="width:90px; margin-left: 0px; padding-right: 0px; border: 0px !important; color: black !important;"
        >
          Prekliči
        </el-button>
        <el-button
          @click="urediDialog = false; odjaviDeaktivirajPopup = true;"
          type="primary"
          style="font-weight: bold;"
        >ODSTRANI</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Shields from '../../../../../assets/js/T2Shield/Shields'
import IzdelkiBox from '../../../../UIComponents/Izdelki/IzdelkiBox.vue'
import Izdelek from '../../../../UIComponents/Izdelki/Izdelek.vue'
import {StoritevEnum} from '../../../../../assets/js/Enum/StoritevEnum'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import {SlovenianCurrencyMixin} from '../../../../../assets/js/Helpers/NumberFormatMixin'
import {Button, Dialog, Icon, Option, Select} from 'element-ui'
import SpremembaStoritevPopup from '../SpremembaStoritevPopup.vue'
import InfoKomponentaGlobalna from '../../../../UIComponents/InfoKomponentaGlobalna.vue'
import Shield from '../../../../../assets/js/T2Shield/Shield'
import {FormatDatuma} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/FormatDatuma'
import {povezave} from '../../../../../assets/js/Povezave/povezave'

export default {
  name: 'NarociScit',
  components: {
    InfoKomponentaGlobalna,
    SpremembaStoritevPopup,
    OrderButton,
    Izdelek,
    IzdelkiBox,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [Icon.name]: Icon
  },
  mixins: [SlovenianCurrencyMixin],
  props: {
    idCustomer: {
      type: Number,
      required: true
    },
    idTerminationPoint: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      shields: Shields.getInstance(this.idCustomer),
      shieldsLoaded: false,
      shieldsReLoaded: false,
      vrstniRedShieldov: [StoritevEnum.SCITFIX, StoritevEnum.SCITMOB, StoritevEnum.SCITPAKET],
      narociAktivirajPopup: false,
      selectedShieldService: null,
      selectedShield: null,
      orderNewShield: false,
      removeExistingShield: false,
      narociVklopiLoading: false,
      odjaviDeaktivirajPopup: false,
      oddajZahtevekPopup: false,
      oddajZahtevekTitle: 'Ni mogoče naročiti T-2 Ščita',
      oddajZahtevekText: '',
      oddajZahtevekLoading: false,
      narociAktivirajText: '',
      xxsScreen: false,
      xsScreen: false,
      smallScreen: false,
      smallToMedScreen: false,
      largeScreen: false,
      urediDialog: false,
      strinjanjeZaAktivacijo: false,
      expandRowKeys: [],
      povezavaSplosniPogojiStoritve: povezave.BASE_URL_SPLOSNI_POGOJI_T2_SCIT
    }
  },
  computed: {
    mobilniPrikljucekPopupWording () {
      return this.selectedShieldService.maxConnectedMobiles === 1
        ? 'Mobilni priključek:'
        : this.selectedShieldService.maxConnectedMobiles === 2
          ? 'Mobilna priključka:'
          : this.shields.mobileTerminationPointsForOrder.length > 1
            ? 'Mobilni priključki:'
            : 'Mobilni priključek:'
    },
    narociVklopiAktivirajDisabledButton () {
      return !this.strinjanjeZaAktivacijo && this.aktivirajInDiamantAliKing
    },
    aktivirajInDiamantAliKing () {
      return this.selectedShieldService.includedInPackage && this.hasPackage(true, true)
    },
    circleIcon () {
      return this.$screen.width < 1100
    },
    FormatDatuma () {
      return FormatDatuma
    },
    servicesForOrder () {
      let out = []
      if (this.orderNewShield) {
        if (this.selectedShieldService.id === StoritevEnum.SCITMOB) {
          this.selectedShield.toBeConnectedShields.forEach((cs) => {
            out.push({
              serviceId: this.selectedShieldService.id,
              quantity: 1,
              terminationPointId: cs
            })
          })
        } else {
          let connectedIds = []
          this.selectedShield.toBeConnectedShields.forEach((cs) => {
            connectedIds.push({
              key: 'idConnectedTerminationPoint',
              value: cs
            })
          })
          out.push({
            serviceId: this.selectedShieldService.id,
            quantity: 1,
            terminationPointId: this.selectedShield.terminationPointId,
            additionalData: connectedIds
          })
        }
      } else {
        out.push({
          serviceId: this.selectedShield.activeService.id,
          quantity: 0,
          terminationPointId: this.selectedShield.terminationPointId
        })
      }

      return out
    },
    StoritevEnum () {
      return StoritevEnum
    },
    izdelkiZaDoticniPrikljucek () {
      let out = this.shields.getPossibleShieldByTerminationPoint(this.idTerminationPoint)
      if (out === null) {
        out = []
      } else {
        out = [out]
      }
      let firstMobileShield = this.shields.getFirstMobileShield()
      if (firstMobileShield !== null) {
        out.push(firstMobileShield)
      }
      return out
    }
  },
  methods: {
    expandChange (item, items) {
      let out = []
      items.forEach((item) => {
        out.push(item.terminationPointId)
      })
      this.expandRowKeys = out
    },
    async oddajZahtevekClick () {
      try {
        this.oddajZahtevekLoading = true
        await this.selectedShield.sendOrderRequest()
        this.ShowSuccessMessage({message: 'Zahtevek uspešno oddan'})
      } catch (e) {
        e.duration = 0
        this.ShowWarningMessage(e)
      }
      this.oddajZahtevekLoading = false
      this.oddajZahtevekPopup = false
    },
    hasPackage (king, diamant) {
      const arr = this.izdelkiZaDoticniPrikljucek
      return arr.some(s =>
        (king && s.paketKing) || (diamant && s.paketOranzniDiamant)
      )
    },
    getIntroText () {
      let out = 'T-2 Ščit je spletna zaščita, namenjena odkrivanju in preprečevanju potencialno nevarnih ali ' +
        'sumljivih spletnih dejavnosti. Več informacij o storitvi T-2 Ščit najdete na naši ' +
        '<a href="https://www.t-2.net/t-2-scit" target="_blank">spletni strani</a>. ' +
        'Storitev je na voljo kot samostojno naročilo ter v paketih Oranžni Diamant in Oranžni King.'
      if (this.hasPackage(true, true)) {
        let textDodatek = ''
        for (let i = 0; i < this.izdelkiZaDoticniPrikljucek.length; i++) {
          if (this.izdelkiZaDoticniPrikljucek[i].packageDescription !== null) {
            textDodatek = this.izdelkiZaDoticniPrikljucek[i].packageDescription
          }
        }
        out += '<br><br>' + textDodatek
      } else {
        out += '<br><br>' + 'Za vse nove naročnike je storitev T-2 Ščit prvi mesec brezplačna.'
      }
      return out
    },
    narociAktivirajClick () {
      if (this.selectedShieldService.includedInPackage) { // AKTIVIRAJ
        if (this.selectedShield.device === null) {
          this.oddajZahtevekPopup = true
        }
        if (this.selectedShieldService.id === StoritevEnum.SCITPAKET) {
          this.oddajZahtevekTitle = 'Aktivacija paketa T-2 Ščit ni bila uspešna'
          this.oddajZahtevekText = 'Znotraj storitve T-2 Ščit <b>smo uspešno aktivirali vaš mobilni priključek</b>. Za' +
            ' vklop zaščite v domačem omrežju pa je potrebna zamenjava omrežne opreme. Brezplačno menjavo lahko' +
            ' uredite s klicem na 064 064 064, v poslovalnicah T-2 ali z oddajo zahtevka. Po zamenjavi omrežne opreme' +
            ' lahko dokončate aktivacijo zaščite na fiksnem priključku.'
          if (this.shields.mobileTerminationPointsForOrder.length === 1) {
            this.selectedShield.toBeConnectedShields = [this.shields.mobileTerminationPointsForOrder[0].terminationPointId]
          }
          if (this.selectedShieldService.maxConnectedMobiles === 1) {
            this.narociAktivirajText = 'Za aktivacijo T-2 Ščit Paket prosimo, izberite mobilni priključek, na ' +
              'katerem želite vklopiti zaščito.'
          } else {
            this.narociAktivirajText = 'Za aktivacijo T-2 Ščit Paket prosimo, izberite mobilna priključka, na ' +
              'katerih želite vklopiti zaščito.'
          }
        }
      } else { // NAROČI
        this.oddajZahtevekTitle = 'Ni mogoče naročiti T-2 Ščita'
        this.oddajZahtevekText = 'Oprostite, naročilo storitve T-2 Ščit ni možno. Za vklop storitve je potrebna ' +
          'zamenjava omrežne opreme. Brezplačno menjavo opreme lahko uredite s klicem na 064 064 064, v ' +
          'poslovalnicah T-2 ali z oddajo zahteve za menjavo. Po vklopu nove omrežne opreme lahko opravite naročilo.'
        if (this.selectedShield.device === null) {
          this.oddajZahtevekPopup = true
        }
        if (this.selectedShieldService.id === StoritevEnum.SCITMOB) {
          if (this.shields.mobileTerminationPointsForOrder.length === 1) {
            this.narociAktivirajText = 'Ste prepričani, da želite naročiti T-2 Ščit za mobilni priključek?'
            this.selectedShield.toBeConnectedShields =
              [this.shields.mobileTerminationPointsForOrder[0].terminationPointId]
          }
          if (this.shields.mobileTerminationPointsForOrder.length > 1) {
            this.narociAktivirajText = 'Za naročilo izberite mobilni priključek, na katerem želite vklopiti T-2 Ščit ' +
              'Mobilni. Izberete lahko enega ali več mobilnih priključkov.'
          }
        }
        if (this.selectedShieldService.id === StoritevEnum.SCITPAKET) {
          this.oddajZahtevekTitle = 'Naročilo T-2 Ščita ni na voljo'
          this.oddajZahtevekText = 'Žal trenutno naročilo storitve T-2 Ščit paket ni mogoče. Za' +
            ' vklop storitve je potrebna zamenjava omrežne opreme. Brezplačno menjavo lahko' +
            ' uredite s klicem na 064 064 064, v poslovalnicah T-2 ali z oddajo zahtevka. Po zamenjavi omrežne opreme' +
            ' boste lahko dokončali naročilo.'
          if (this.shields.mobileTerminationPointsForOrder.length === 1) {
            this.selectedShield.toBeConnectedShields =
              [this.shields.mobileTerminationPointsForOrder[0].terminationPointId]
          }
          this.narociAktivirajText = 'Za naročilo T-2 Ščit Paket prosimo, izberite mobilni priključek, na ' +
            'katerem želite vklopiti zaščito.'
        } else if (this.selectedShieldService.id === StoritevEnum.SCITFIX) {
          this.oddajZahtevekTitle = 'Naročilo T-2 Ščita ni na voljo'
          this.oddajZahtevekText = 'Žal trenutno naročilo storitve T-2 Ščit fiksni ni mogoče. Za' +
            ' vklop storitve je potrebna zamenjava omrežne opreme. Brezplačno menjavo lahko' +
            ' uredite s klicem na 064 064 064, v poslovalnicah T-2 ali z oddajo zahtevka. Po zamenjavi omrežne opreme' +
            ' boste lahko dokončali naročilo zaščite na fiksnem priključku.'
          this.narociAktivirajText = 'Ste prepričani, da želite naročiti T-2 Ščit za fiksni priključek?'
        }
      }
      if (!this.oddajZahtevekPopup) {
        this.narociAktivirajPopup = true
      }
    },
    async connectedShieldChanged (shield, atp) {
      try {
        atp.loading = true
        await shield.editConnectedShield()
        await this.shields.reloadMobileTerminationPoints()
        await shield.loadShield()
        atp.loading = false
        this.$forceUpdate()
        this.ShowSuccessMessage({message: 'Mobilna številka uspešno zamenjana.'})
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    async addNewConnectedShield (shield, atp) {
      try {
        atp.loading = true
        await shield.addNewConnectedShield(atp.toBeAddedShield)
        await this.shields.reloadMobileTerminationPoints()
        await shield.loadShield()
        atp.loading = false
        this.$forceUpdate()
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    spremembaKonfiguracijeLabelClick (atp) {
      if (atp.shield.configurationAllowed) {
        atp.shield.configurationChanges = !atp.shield.configurationChanges
        this.spremembaShieldKonfiguracije(atp.shield)
      }
    },
    async spremembaShieldKonfiguracije (shield) {
      shield.loading = true
      try {
        let tmpShield = new Shield(shield.terminationPointId, shield.customerId)
        if (shield.configurationChanges) {
          await tmpShield.configure()
          shield.configured = true
          this.ShowSuccessMessage({message: 'Zaščita T-2 Ščit uspešno vklopljena.'})
        } else {
          await tmpShield.deconfigure()
          shield.configured = false
          this.ShowSuccessMessage({message: 'Zaščita T-2 Ščit uspešno izklopljena.'})
        }
      } catch (e) {
        shield.configurationChanges = !shield.configurationChanges
        e.duration = 0
        this.ShowErrorMessage(e)
      }
      shield.loading = false
    },
    async narociVklopiClick () {
      if (this.selectedShieldService.includedInPackage) {
        try {
          this.narociVklopiLoading = true
          await this.selectedShield.activate(this.selectedShieldService)
          await this.reloadShields(true)
          this.narociAktivirajPopup = false
          if (this.selectedShield.device === null) {
            this.oddajZahtevekPopup = true
          } else {
            this.ShowSuccessMessage(
              {message: 'Zaščita ' + this.selectedShieldService.title + ' je bila uspešno aktivirana.'}
            )
          }
          this.strinjanjeZaAktivacijo = false
        } catch (e) {
          e.duration = 0
          this.ShowErrorMessage(e)
        }
        this.narociVklopiLoading = false
      } else {
        // oddamo novo naročilo preko dokumentov
        this.orderNewShield = true
      }
    },
    async removeShield () {
      if (this.selectedShieldService.includedInPackage) {
        try {
          this.narociVklopiLoading = true
          await this.selectedShield.deactivate()
          await this.reloadShields(true)
          this.ShowSuccessMessage({message: 'Uspešno deaktivirana zaščita T-2 Ščit.'})
        } catch (e) {
          e.duration = 0
          this.ShowErrorMessage(e)
        }
        this.narociVklopiLoading = false
      } else {
        // oddamo novo naročilo preko dokumentov
        this.removeExistingShield = true
      }
      this.odjaviDeaktivirajPopup = false
    },
    async reloadShields (override) {
      this.shieldsReLoaded = false
      try {
        await this.shields.loadShields(override)
        this.shieldsLoaded = true
        this.shieldsReLoaded = true
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    }
  },
  watch: {
    idCustomer: {
      immediate: true,
      handler () {
        this.shields = Shields.getInstance(this.idCustomer)
        this.reloadShields(false)
      }
    },
    idTerminationPoint: {
      immediate: true,
      handler () {
        this.expandRowKeys = [this.idTerminationPoint]
      }
    },
    '$screen.width': {
      immediate: true,
      handler (newVal) {
        this.xxsScreen = newVal < 450
        this.xsScreen = newVal < 550
        this.smallScreen = newVal < 700
        this.smallToMedScreen = newVal < 800
        this.largeScreen = newVal > 1200
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociVarnostnaZascita/NarociScit.vue